var map = {
	"./520x_01.png": "cb47",
	"./520x_02_en.png": "0d5a",
	"./520x_02_zh-TW.png": "7145",
	"./520x_03.png": "9f73",
	"./520x_04_book.png": "6770",
	"./520x_05_book.png": "45d2",
	"./520x_06.png": "a175",
	"./cross_0.png": "4a57",
	"./cross_1.png": "e9fc",
	"./cross_2.png": "550c",
	"./cross_3.png": "c3d4",
	"./cross_4.png": "23c0",
	"./cross_5.png": "236a",
	"./daylight_0.png": "28c9",
	"./daylight_1.png": "86ec",
	"./daylight_2.png": "21bd",
	"./daylight_3.png": "cbaa",
	"./daylight_4.png": "50ad",
	"./daylight_5.png": "151c",
	"./dynamic_1.png": "9d6e",
	"./dynamic_2.png": "f665",
	"./dynamic_3.png": "893b",
	"./dynamic_4.png": "868e",
	"./dynamic_5.png": "df2e",
	"./lightmode_cross.png": "2761",
	"./lightmode_daylight.png": "7304",
	"./lightmode_parallel.png": "d342",
	"./lightmode_pigmentation.png": "3208",
	"./lightmode_texture.png": "b62d",
	"./lightmode_trueuv.png": "82df",
	"./lightmode_vascularity.png": "0540",
	"./lightmode_woods.png": "4cfd",
	"./parrallel_0.png": "c7d5",
	"./parrallel_1.png": "c6d4",
	"./parrallel_2.png": "fa77",
	"./parrallel_3.png": "2ee2",
	"./parrallel_4.png": "f34c",
	"./parrallel_5.png": "edf6",
	"./pigment_0.png": "9a26",
	"./pigment_1.png": "6076",
	"./pigment_2.png": "7277",
	"./pigment_3.png": "d3f5",
	"./pigment_4.png": "78d5",
	"./pigment_5.png": "de77",
	"./redness_0.png": "58d2",
	"./redness_1.png": "94f7",
	"./redness_2.png": "10db",
	"./redness_3.png": "31f1",
	"./redness_4.png": "43ef",
	"./redness_5.png": "8f2b",
	"./texture_0.png": "0652",
	"./texture_1.png": "6d6b",
	"./texture_2.png": "7a9b",
	"./texture_3.png": "8de2",
	"./texture_4.png": "fc6c",
	"./texture_5.png": "230d",
	"./uv_0.png": "c24f",
	"./uv_1.png": "2044",
	"./uv_2.png": "06f5",
	"./uv_3.png": "d707",
	"./uv_4.png": "ab95",
	"./uv_5.png": "9141",
	"./woods_0.png": "8c8a",
	"./woods_1.png": "c89f",
	"./woods_2.png": "dba7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24ae";